import React, { ReactElement } from "react";
import { Box } from "theme-ui";
import { CardPrimaryType } from "./card-primary";

export const CardHorizontal = ({
  hasPadding,
  children,
  ...props
}: CardPrimaryType): ReactElement => {
  const variant = hasPadding
    ? "cards.horizontal.content"
    : "cards.horizontal.default";
  return (
    <Box variant={variant} {...props}>
      {children}
    </Box>
  );
};
